
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const navigate = useNavigate();
  const { user, isAdmin, isClient, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth');
  };

  if (!user) {
    return null;
  }

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-2">
              <i className="ri-scales-3-line text-2xl text-teal-600"></i>
              <span className="text-xl font-bold text-gray-900">RC Process</span>
            </Link>
            
            <div className="hidden md:flex items-center space-x-6">
              {isAdmin && (
                <>
                  <Link 
                    to="/client-management" 
                    className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Client Portal
                  </Link>
                  <Link 
                    to="/server-management" 
                    className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Servers
                  </Link>
                  <Link 
                    to="/court-management" 
                    className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Courts
                  </Link>
                  <Link 
                    to="/store-management" 
                    className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Stores
                  </Link>
                  <Link 
                    to="/customer-loans" 
                    className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Customer Loans
                  </Link>
                </>
              )}
              
              {isClient && (
                <Link 
                  to="/client-portal" 
                  className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  My Portal
                </Link>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-user-line text-teal-600"></i>
              </div>
              <span className="text-sm text-gray-700 hidden sm:block">{user.email}</span>
            </div>
            <button
              onClick={handleSignOut}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
